import GroceryCmp from "../Components/Groceries/Groceries";
import useTitle from "../hooks/useTitle";
const Groceries = () => {
  useTitle("Groceries");
  return <GroceryCmp />;
};

export default Groceries;
